import { ImpactSize, ImpactType } from './glass-impact';

export const contactPeriodTimeValues: string[] = [
  'GlobalApplicativeConstants.contactPeriodTimes.nextHour',
  'GlobalApplicativeConstants.contactPeriodTimes.morning',
  'GlobalApplicativeConstants.contactPeriodTimes.lunchTime',
  'GlobalApplicativeConstants.contactPeriodTimes.afternoon',
];

export const allImpactsTypes: { key: ImpactType; value: string }[] = [
  {
    key: 'crack',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.crack',
  },
  {
    key: '2impactsLess',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.2impactsLess',
  },
  {
    key: '3impactsLess',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.3impactsLess',
  },
  {
    key: '3impactsMore',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.3impactsMore',
  },
  {
    key: '1impact',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.1impact',
  },
  {
    key: '2or3impacts',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.2or3impacts',
  },
  {
    key: 'more3impactsOrCrack',
    value:
      'GlobalApplicativeConstants.sinisterGlass.glassImpact.more3impactsOrCrack',
  },
];

export const allImpactsSizes: { key: ImpactSize; value: string }[] = [
  {
    key: 'smaller2cm',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.smaller2cm',
  },
  {
    key: 'bigger2cm',
    value: 'GlobalApplicativeConstants.sinisterGlass.glassImpact.bigger2cm',
  },
];

export const allSinisterContexts: { key: string; value: string }[] = [
  {
    key: 'G',
    value: 'GlobalApplicativeConstants.SinisterContexts.G',
  },
  {
    key: 'NE',
    value: 'GlobalApplicativeConstants.SinisterContexts.NE',
  },
  {
    key: 'T',
    value: 'GlobalApplicativeConstants.SinisterContexts.T',
  },
  {
    key: 'V',
    value: 'GlobalApplicativeConstants.SinisterContexts.V',
  },
  {
    key: 'A',
    value: 'GlobalApplicativeConstants.SinisterContexts.A',
  },
  {
    key: 'P',
    value: 'GlobalApplicativeConstants.SinisterContexts.P',
  },
  {
    key: 'U',
    value: 'GlobalApplicativeConstants.SinisterContexts.U',
  },
  {
    key: 'O',
    value: 'GlobalApplicativeConstants.SinisterContexts.O',
  },
];
